import React, { useState, useEffect, useRef } from 'react';
import './SliderLanding.css';
import '../Pagina.css';
//import '../Animate/animate.css';

//import { set_language, content_language, translate} from '../../../Utils';

//import "swiper/swiper-bundle.min.css";

const Slider = (props) => {

    const [, set_dados] = useState(null);
	const banner = useRef(null);

    const [isloading, setLoading] = useState(true);

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
           
            let aux = []
            aux.push(props.dados_config.content[0].banner)
            set_dados(banner.current = aux)

            //setTimeout(() => {
                setLoading(false)
            //}, 150)

        }

    }, [props])

    return (
        isloading ?
            null
		:
            banner.current !== undefined && banner.current !== null ?
                <table cellSpacing="0" cellPadding="0" align="center" className="es-content slnl" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', width: '100%', tableLayout: 'fixed !important' }} >
                    <tbody>
                        <tr style={{ borderCollapse: 'collapse' }}>
                            <td align="center" style={{ padding: '0', margin: '0' }}>
                                <table cellSpacing="0" cellPadding="0" bgcolor="#ffffff" align="center" className="es-content-body" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', backgroundColor: '#FFFFFF', width: '600px', borderTop: '1px solid #eaeaea' }}>
                                    <tbody>
                                        <tr style={{ borderCollapse: 'collapse' }}>
                                            <td align="left" style={{ padding: '0', margin: '0' }}>
                                                <table width="600" cellSpacing="0" cellPadding="0" role="none" style={{ width: '600px', msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }}>
                                                    <tbody>
                                                        <tr style={{ borderCollapse: 'collapse' }}>
                                                            <td valign="top" align="center" style={{ padding: '0', margin: '0', width: '600px' }}>
                                                                <table width="600" cellSpacing="0" cellPadding="0" role="presentation" style={{ width: '600px', msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }}>
                                                                    <tbody>
                                                                        <tr style={{ borderCollapse: 'collapse' }}>
                                                                            <td align="center" style={{ padding: '0', margin: '0', position: 'relative' }}>
                                                                                <img 
                                                                                    src={banner.current.length > 0 && banner.current[0].link !== '' ? banner.current[0].link : ''}
                                                                                    alt="" 
                                                                                    title="" 
                                                                                    className="img-fluid" 
                                                                                    width="600"
                                                                                    style={{ width: '600px', maxWidth: '600px', display: 'block', fontSize: '14px', border: '0', outline: 'none', textDecoration: 'none' }} 
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            :
                null
    )
};
export default Slider;